import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

import SmartList from './SmartList';
import { updateMultipleFiltersData } from '../Filters/redux/actions';
import { getSmartListStart, resetSmartList } from './redux/actions';
import { selectListData } from './redux/selectors';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';

const SmartListContainer = props => {
  return <SmartList {...props} />;
};

export const mapDispatchToProps = dispatch => {
  return {
    getSmartListStart: (payload, id) =>
      dispatch(getSmartListStart(payload, id)),
    updateMultipleFiltersData: payload =>
      dispatch(updateMultipleFiltersData(payload)),
    resetSmartList: () => dispatch(resetSmartList()),
  };
};

export const mapStateToProps = createStructuredSelector({
  contentListData: selectListData,
});

export default withErrorBoundary(connect(mapStateToProps, mapDispatchToProps)(SmartListContainer));
